import _ from 'underscore';
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Thumbnail from 'components/Thumbnail';
import Icon from 'components/Icon';

import styles from './styles.module.scss';

const MediaCard = ({ className, title, type, image, active, onClick }) => {
	const footerCx = cx(
		styles.MediaCard__Footer,
		{
			[styles.MediaCard__Footer_active]: active
		},
		className
	);

	const handleClick = useCallback(() => {
		onClick(type);
	}, [type, onClick]);

	return (
		<button type="button" className={styles.MediaCard} onClick={handleClick}>
			<span className={styles.MediaCard__Inner}>
				<Thumbnail
					className={styles.MediaCard__Image}
					file={image}
					keepRatio={false}
					params={{ height: 400 }}
				/>
				<span className={footerCx}>
					<span className={styles.MediaCard__Title}>{title}</span>
					<Icon
						className={cx(styles.MediaCard__Icon, 'pvi-no-styles')}
						icon="chevronBottomRounded"
						useClassName="pvi-no-styles"
					/>
				</span>
			</span>
		</button>
	);
};

MediaCard.propTypes = {
	className: PropTypes.string,
	active: PropTypes.bool,
	title: PropTypes.string.isRequired,
	type: PropTypes.oneOf([
		'infographic',
		'tours',
		'gallery',
		'broadcast',
		'events',
		'performances'
	]).isRequired,
	image: PropTypes.object.isRequired,
	onClick: PropTypes.func
};

MediaCard.defaultProps = {
	active: false,
	onClick: _.noop
};

export default MediaCard;
